module.exports = __webpack_public_path__ + "assets/img/março-on-fire-restaurantes-feed.06f14a7e.png";